exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dimmer{background:#fff;opacity:.8;top:0;left:0;width:100%;height:100%;z-index:9999;display:flex;align-items:center;justify-content:center}.dimmer,.spinner{position:absolute}.spinner{height:60px;width:60px;margin:0 auto;top:50%;margin-top:-30px;left:50%;margin-left:-30px;animation:rotation .6s infinite linear;border-left:6px solid rgba(0,174,239,.15);border-right:6px solid rgba(0,174,239,.15);border-bottom:6px solid rgba(0,174,239,.15);border-top:6px solid rgba(0,174,239,.8);border-radius:100%}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/common/spinner/spinner.styl
// module id = 581
// module chunks = 0